import { OdataManager } from '@/api/odata/odata-manager';
import { DocumentType } from '@/api/model/interfaces';

export default class DocumentTypeOdata extends OdataManager<DocumentType> {}
